// extracted by mini-css-extract-plugin
export default {"confirmationModalText":"styles_confirmationModalText__fLd9J"};